
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seller-profile/[sellerId]",
      function () {
        return require("private-next-pages/seller-profile/[sellerId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seller-profile/[sellerId]"])
      });
    }
  